export const RenderActionTitle = ({ getCurrentFeature, isEdit, tenantName }) => {
  const currentFeature = getCurrentFeature();
  if (isEdit) {
    return 'Save and Return to Application Summary';
  }
  return currentFeature?.itemType === 'ApplicantProperty' &&
    tenantName !== 'bhcipcce' &&
    tenantName !== 'ici'
    ? 'Submit Ownership and Continue'
    : 'Continue';
};
